import { useState } from "react";
import { FilterTableProps } from "./types/filter-table-props.type";
import { Button } from "../ui/button";
import { FilterIcon } from "../icons";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const FilterTable = ({ filters, onCheckedChange }: FilterTableProps) => {
  const [open, setOpen] = useState(false);

  const onSelect = (key: number, value: boolean) => {
    const newFilter = filters.map((item, idx) => (idx === key ? { ...item, isShow: value } : item));
    onCheckedChange(newFilter);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="border border-color-icon">
          <FilterIcon />
          Filtres
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto space-y-2">
        {filters?.map((item, idx) => (
          <div className="flex items-center gap-3" key={item.value}>
            <Checkbox
              id={`payment-${item.value}`}
              checked={item.isShow}
              className="data-[state=checked]:bg-[#1E5F6F] data-[state=checked]:border-[#1E5F6F] border-[#25292D]"
              onCheckedChange={(checked) => {
                onSelect(idx, checked === true);
              }}
            />
            <Label htmlFor={`payment-${item.value}`} className="cursor-pointer font-extrabold text-xs">
              {item.label}
            </Label>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};
